const Shimmer = () => {
    return (<>
    <div className="restaurant-list">
        {Array(22).fill("").map(e=>
            <div className="shimmer-wrapper">    
        </div>)
        }
        </div>
    </>);
};

export default Shimmer;